import { CustomerDetailFullAccount } from '../../../../../store/customerDetail/types';
import {
  withdrawalCheckErrorTooltipMessage,
  withdrawalJudicialBlockReasonId,
  withdrawalJudicialBlockTooltipMessage,
} from '../../../../../store/customerDetail/withdrawal/constants';

export const blockStatusTooltipMessage = 'Bloqueado - Cadastro com Pendência';

export const hasPendingBlock = (
  customer: CustomerDetailFullAccount | null | undefined
): boolean => {
  if (!customer) {
    return false;
  }

  return customer.pendingRegistrationReasons.some((group) => group.reasons.length > 0);
};

export const getBlockStatusTooltip = (
  customer: CustomerDetailFullAccount | null | undefined,
  isLoading: boolean,
  hasError: boolean
): string | undefined => {
  if (isLoading || hasError || !customer) {
    return undefined;
  }

  if (customer.pendingRegistrationCheckError) {
    return withdrawalCheckErrorTooltipMessage;
  }

  const hasJudicialBlock = customer.pendingRegistrationReasons
    .flatMap((group) => group.reasons)
    .some((reason) => reason.id === withdrawalJudicialBlockReasonId);

  if (hasJudicialBlock) {
    return withdrawalJudicialBlockTooltipMessage;
  }

  if (hasPendingBlock(customer)) {
    return blockStatusTooltipMessage;
  }

  return undefined;
};
